import React, { Component } from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'

import StepGuide from './step-guide'
import data from './data.json'
import './style.scss'
import pic from '../../../../images/stepguide.jpg'
//import pic_mobile from '../../../../images/pic_mobile.jpg'
//import pic_tablet from '../../../../images/pic_tablet.jpg'
//import pic_desktop from '../../../../images/pic_desktop.png'

export default class StepGuidePage extends Component {
  constructor(props) {
    super(props)
    this.stepGuideRef = React.createRef()
  }

  toggleExample = () => {
    this.stepGuideRef.current.toggle()
  }
  render() {
    return (
      <>
        <Header
          site={data.site}
          slug={data.slug + '/develop/'}
          state="develop"
          title={data.title}
          exclusive={true}
        />
        <Layout
          category="Overview"
          site={data.site}
          slug={data.slug + '/develop/'}
          state="develop"
          title={data.title}
        >
          <Intro>
            <p>
              The step guide pattern takes the user through a series of steps in
              order to complete a particular task. It is similar in structure to
              a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/modal/develop'}
              >
                modal
              </Link>
              , and the fullscreen container always usurps control of the
              window. The required elements are the "Close" action, the guide
              title, the step title, body content and a customized version of
              the persistent{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/action-group/develop'}
              >
                action group
              </Link>{' '}
              pattern, which allows the user to navigate forward and backward in
              the step order. Body content will vary depending on the task. Add
              a guide description to briefly summarize the body content when
              necessary. A{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/divider/develop'}
              >
                divider
              </Link>{' '}
              may be used to separate the description from body content.
            </p>
          </Intro>
          <SectionTitle>Variations</SectionTitle>

          <Showcase
            site={data.site}
            title="Default"
            oversized={true}
            code={code.stepGuide}
            handler={this.toggleExample}
            text="Signals that the body content is in the initial scroll position, or that there is nothing to scroll. Note that the persistent action group always appears with a medium shadow, even when there is no content overflow."
          >
            <img class="step-guide_image" src={pic} alt="Default step guide." />
            <StepGuide ref={this.stepGuideRef} />
          </Showcase>
          <SectionTitle>Design Environment</SectionTitle>
          <p>
            The primary button will always drive the user forward in the flow,
            and the left arrow button will always bring the user back to the
            previous step.The progress bar and step label communicate to the
            user where they are in the step order. If the only purpose of the
            final step is confirmation, remove it and use a success{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/notification/develop'}
            >
              notification
            </Link>{' '}
            instead. Step guides take over the entire screen in all
            environments, so they can only be dismissed with the "Close" action.
          </p>
          <hr />
          <SectionTitle>Design Environment</SectionTitle>
          <p>
            The primary button will always drive the user forward in the flow,
            and the left arrow button will always bring the user back to the
            previous step.The progress bar and step label communicate to the
            user where they are in the step order. If the only purpose of the
            final step is confirmation, remove it and use a success{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/notification/develop'}
            >
              notification
            </Link>{' '}
            instead. Step guides take over the entire screen in all
            environments, so they can only be dismissed with the "Close" action.
          </p>
          <hr />
          <SectionTitle>Microcopy</SectionTitle>
          <p>
            The guide description should be as brief as possible, ideally one or
            two sentences. Try to keep text content in the body concise to avoid
            scrolling if possible. The primary button will usually be "Next" or
            "Submit," depending on the step. Do not duplicate the "Close" action
            with a "Close" button in the last step. Otherwise, follow guidelines
            for the{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/title/develop'}
            >
              title
            </Link>{' '}
            and{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/button/develop'}
            >
              button
            </Link>{' '}
            components.
          </p>
        </Layout>
      </>
    )
  }
}

const code = {
  stepGuide: `
  <div class="p-step-guide">
      <div class="p-step-guide__close-bar">
        <h1 class="p-step-guide__close-bar-title">Header</h1>
        <button class="p-step-guide__close-bar-button" onClick="toggleDefault()" onKeyDown="toggleDefault()">
          <i class="icon icon--x p-step-guide__close-bar-button-icon"></i>
          <span class="p-step-guide__close-bar-button-text">Close</span>
        </button>
      </div>
      <!--Step 1-->
      <div class="p-step-guide__content scrollModalContent">
        <div class="p-step-guide__header">
          <div class="p-step-guide__eyebrow">Step Description: This is Step 1</div>
          <h1 class="p-step-guide__header-title">Step Title: Step 1</h1>
        </div>
        <p class="l-margin-bottom--medium">
          Step 1 Content
        </p>
        <hr class="c-divider l-margin-vertical--large" />
      </div>
      <!--Step 2-->
      <div class="p-step-guide__content scrollModalContent">
        <div class="p-step-guide__header">
          <div class="p-step-guide__eyebrow">Step Description: This is Step 2</div>
          <h1 class="p-step-guide__header-title">Step Title: Step 2</h1>
        </div>
        <p>Step 2 Content</p>
        <hr class="c-divider l-margin-vertical--large" />
      </div>
      <!--Step 3-->
      <div class="p-step-guide__content scrollModalContent">
        <div class="p-step-guide__header">
          <div class="p-step-guide__eyebrow">Step Description: This is Step 3</div>
          <h1 class="p-step-guide__header-title">Step Title: Step 3</h1>
        </div>
        <p>Step 3 Content</p>
        <hr class="c-divider l-margin-vertical--large" />
      </div>
      <div class="p-step-guide__footer">
        <div class="c-progress-bar--step-guide">          
          <progress id="progress" value="33" max="100"> 33% </progress>
        </div>
        <div class="p-step-guide__footer--left">
          <button id="prevBtn" class="p-step-guide__footer--left-button icon icon--arrow-with-tail-left p-step-guide__footer--left-button-icon" onclick="nextPrev(-1)">
          <span class="p-step-guide__footer--left-button-text">Back</span></button>
          <span class="p-step-guide__footer-vertical-border"></span>
          <div class="p-step-guide__pagination">
            <span class="p-step-guide__pagination--first-number">1</span> of <span class="p-step-guide__pagination--last-number">3</span>
          </div>
        </div>
        <div class="p-step-guide__footer--right">
          <button id="nextBtn" onclick="nextPrev(1)" class="p-step-guide__button--primary">Next</button>
        </div>
      </div>
    </div> `,
}
